import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-[#1A1A1A] text-[#FFF8F0] py-12 px-4 mt-auto" data-id="element-10">
      <div className="max-w-4xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8 text-center md:text-left" data-id="element-11">
        <div className="space-y-2" data-id="element-12">
          <h3 className="font-serif text-xl text-[#C5A55A]" data-id="element-13">
            Top Notch Bakery
          </h3>
          <p className="text-sm opacity-80" data-id="element-14">Est. 2021</p>
        </div>

        <div className="flex flex-col gap-3 text-sm opacity-90" data-id="element-15">
          <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-16">
            <MapPinIcon className="h-4 w-4 text-[#C5A55A]" data-id="element-17" />
            <span data-id="element-18">Klostergatan 7, Växjö</span>
          </div>
          <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-19">
            <PhoneIcon className="h-4 w-4 text-[#C5A55A]" data-id="element-20" />
            <span data-id="element-21">0470-52 36 03</span>
          </div>
          <div className="flex items-center justify-center md:justify-start gap-2" data-id="element-22">
            <MailIcon className="h-4 w-4 text-[#C5A55A]" data-id="element-23" />
            <span data-id="element-24">tnbakery@outlook.com</span>
          </div>
        </div>

        <div className="text-xs opacity-50" data-id="element-25">
          &copy; {new Date().getFullYear()} Top Notch Bakery.
        </div>
      </div>
    </footer>;
}